export const getPreviewSummary = state => state.admin.datamodel.previewSummary;
export const getRevisions = state => state.admin.datamodel.revisions;
export const getCurrentUser = state => state.currentUser;
